import { render } from "./designTextareaPrint.vue?vue&type=template&id=ff96c488"
import script from "./designTextareaPrint.vue?vue&type=script&lang=js"
export * from "./designTextareaPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__